import React, { PropsWithChildren } from 'react';
import { useInView } from 'react-intersection-observer';

import EcoCardGuinnessRecordsIllustration from '../../assets/svg-components/eco/card_3_illustration.svg';
import GrowthEmailMarketing from '../../assets/svg-components/growth/purple_section_01_parallax.svg';
import GrowthStartYourBusiness from '../../assets/svg-components/growth/purple_section_02_parallax.svg';
import GrowthSocial from '../../assets/svg-components/growth/purple_section_03.svg';
import AiIllustration from '../../assets/svg-components/support/pink_section_card_03_parallax.svg';
import MeetOfflineIllustration from '../../assets/svg-components/support/pink_section_card_04_parallax.svg';
import CupIllustration from '../../assets/svg-components/support/pink_section_card_05_parallax.svg';
import { cn } from '../../utils/classname';
import { EcoCardCarbonFootprintIllustration } from './eco-carbon-footprint';
import './svg-with-generic-animation.scss';

type NativeSVGProps = JSX.IntrinsicElements['svg'];

interface SVGProps extends PropsWithChildren<NativeSVGProps> {
  name:
    | 'guinness-records'
    | 'email-marketing'
    | 'start-your-business'
    | 'social'
    | 'carbon-footprint'
    | 'ai'
    | 'meet-offline'
    | 'winner-cup';
}

export const SvgWithGenericAnimation: React.FunctionComponent<Partial<SVGProps>> = ({ name }) => {
  let Component = null;
  const { ref, inView, entry } = useInView({
    threshold: 0.5,
    triggerOnce: true
  });

  const props = {
    width: '100%'
  };

  switch (name) {
    case 'guinness-records':
      Component = EcoCardGuinnessRecordsIllustration;
      break;
    case 'email-marketing':
      Component = GrowthEmailMarketing;
      break;
    case 'start-your-business':
      Component = GrowthStartYourBusiness;
      break;
    case 'social':
      Component = GrowthSocial;
      break;
    case 'carbon-footprint':
      Component = EcoCardCarbonFootprintIllustration;
      break;
    case 'ai':
      Component = AiIllustration;
      break;
    case 'meet-offline':
      Component = MeetOfflineIllustration;
      break;
    case 'winner-cup':
      Component = CupIllustration;
      break;
  }

  return (
    <div ref={ref} className={cn('rc-generic-svg-effect', inView && 'rc-generic-svg-effect--animated')}>
      <Component {...props} />
    </div>
  );
};
